import React from 'react';
import { useHistory } from 'react-router-dom';
import EntitySelectionComponent from '../components/EntitySelectionComponent';
import { useEntity } from '../contexts/EntityContext';

const HomePage: React.FC = () => {
    const history = useHistory();
    const { currentEntity } = useEntity();

    // Check if entity is selected
    React.useEffect(() => {
        if (currentEntity) {
            // Redirect to the main page with entity in URL
            history.push(`/home/modulo`);
        }
    }, [currentEntity, history]);

    return (
        <div className="home-page">
            {!currentEntity && <EntitySelectionComponent />}
        </div>
    );
};

export default HomePage; 